<template>
  <div class="register-container">
    <div class="register-container-form">
      <div class="register-container-logo">
        <img src="@/assets/logo-project.png" />
      </div>
      <div class="register-container-title">
        {{ $t('login.Release your inner lion and let it roar') }}
      </div>
      <div v-if="handelSuccess != true">
        <div class="form-header">
          <h3>{{ $t('login.Registration') }}</h3>
        </div>
        <a-form
          ref="registerForm"
          :model="form"
          @finish="handleSubmit"
          :rules="validateRules"
        >
          <a-form-item class="afi-username" name="username">
            <a-input
              v-model:value="form.username"
              placeholder="Lion ID"
              @blur="getEmail"
              autocomplete="false"
            ></a-input>
          </a-form-item>
          <a-form-item class="afi-email" name="email">
            <a-input
              readonly
              v-model:value="form.email"
              :placeholder="$t('login.Email')"
            ></a-input>
          </a-form-item>

          <a-form-item class="afi-code" name="code">
            <a-input
              v-model:value="form.code"
              :placeholder="$t('login.Verification code')"
            ></a-input>
            <a-button @click="sendCode">{{ sendCodeText }}</a-button>
          </a-form-item>

          <a-form-item class="afi-password" name="password">
            <a-input
              v-model:value="form.password"
              type="password"
              autocomplete="false"
              :placeholder="$t('login.Password')"
            ></a-input>
          </a-form-item>
          <a-form-item class="afi-cpassword" name="cpassword">
            <a-input
              v-model:value="form.cpassword"
              type="password"
              autocomplete="false"
              :placeholder="$t('login.Confirm password')"
            ></a-input>
          </a-form-item>

          <a-form-item class="afi-btn-group">
            <a-button class="afi-btn-reg" type="primary" html-type="submit">
              {{ $t('login.Register') }}
            </a-button>
            <router-link :to="{ path: '/login' }">
              <a-button class="afi-btn-login" type="link" html-type="submit">
                {{ $t('login.Log In') }}
              </a-button>
            </router-link>
          </a-form-item>
        </a-form>
      </div>
      <div class="success-handel-panel" v-else>
        <svg-icon icon-class="success"></svg-icon>
        <div class="success-text">{{ $t('login.' + successText) }}</div>
        <div class="success-tip" v-if="isEn">
          The login page is displayed after {{ countdowntime }} seconds
        </div>
        <div class="success-tip" v-else>
          登录页面在{{ countdowntime }}秒后显示
        </div>
        <router-link :to="{ path: '/login' }">
          <a-button class="success-btn-login" type="primary">
            {{ $t('login.Return to Login Page') }}
          </a-button>
        </router-link>
      </div>
      <div class="record-number">
        <a href="https://beian.miit.gov.cn/" target="_blank">
          沪ICP备2021007762号-3
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import { register, retrieveEmail, sendEmailCode } from '@/api/user'
  import { message } from 'ant-design-vue'
  import i18n from '@/locales'

  export default {
    name: 'Login',
    components: {},
    computed: {
      isEn() {
        return i18n.global.locale == 'en-US'
      },
    },
    data() {
      return {
        successText: 'Registered Successfully',
        countdowntime: 5,
        handelSuccess: false,
        sendCodeTimer: 60,
        sendCodeText: this.$t('login.Send Code'),
        submitError: true,
        form: {
          username: '',
          email: '',
          code: '',
          password: '',
          cpassword: '',
        },
        errorLlid: false,
        validateRules: {
          username: [
            {
              validator: async () => {
                return new Promise((resolve, reject) => {
                  if (this.form.username == '') {
                    reject(this.$t('login.Please input Lion ID'))
                  } else {
                    setTimeout(() => {
                      if (this.errorLlid == false) {
                        resolve()
                      } else {
                        reject(this.$t('login.Please input a Valid Lion ID'))
                      }
                    }, 300)
                  }
                })
              },
              trigger: 'blur',
            },
          ],
          // email: [
          //   {
          //     required: true,
          //     message: 'Please input Lion ID',
          //     trigger: 'blur',
          //   },
          // ],
          password: [
            {
              required: true,
              message: this.$t('login.Please enter your password'),
              trigger: 'blur',
            },

            {
              pattern: '^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{8,12}$',
              message: this.$t(
                'login.Password must be 8-12 characters,no spaces and must contain at lease 3 of these characters:1 uppercase,1 lowercase,1 number'
              ),
              trigger: 'blur',
            },
          ],
          code: [
            {
              required: true,
              message: this.$t(
                'login.Please enter the Vertification code received from the email'
              ),
              trigger: 'blur',
            },
          ],
          cpassword: [
            {
              validator: async () => {
                if (this.form.password != this.form.cpassword) {
                  return Promise.reject(
                    this.$t(
                      'login.Your password do not match. Please try again'
                    )
                  )
                } else {
                  return Promise.resolve()
                }
              },
              trigger: 'blur',
            },
          ],
        },
      }
    },
    methods: {
      sendCode() {
        if (
          this.sendCodeText === this.$t('login.Send Code') &&
          this.form.email != ''
        ) {
          this.sendCodeText = this.sendCodeTimer + 's'
          const handel = setInterval(() => {
            this.sendCodeTimer--
            this.sendCodeText = this.sendCodeTimer + 's'
            if (this.sendCodeTimer === 0) {
              clearInterval(handel)
              this.sendCodeTimer = 60
              this.sendCodeText = this.$t('login.Send Code')
            }
          }, 1000)
          sendEmailCode(this.form.username)
        } else {
          message.error(
            'Please fill in Lion ID and get your email address first.'
          )
        }
      },
      getEmail(val) {
        const llid = val.target.value
        if (llid !== '') {
          retrieveEmail(llid).then(
            (res) => {
              this.form.email = res.email
              this.errorLlid = false
            },
            (res) => {
              this.errorLlid = true
              // message.error('Invalid Lion ID')
            }
          )
        }
      },
      async handleSubmit() {
        register(this.form).then(
          (res) => {
            this.handelSuccess = true

            const handel = setInterval(() => {
              this.countdowntime--
              if (this.countdowntime == 0) {
                clearInterval(handel)
                this.$router.push({ path: '/login' })
              }
            }, 1000)
          },
          (res) => {
            message.error(res.msg)
          }
        )
      },
    },
  }
</script>
<style lang="less">
  .register-container {
    width: 100%;
    height: 100vh;
    min-width: 1440px;
    background-image: url('~@/assets/login_images/home_background.webp');
    background-size: contain;
    background-position: bottom left;
    background-repeat: no-repeat;
    background-color: #010000;
    &-logo {
      width: 264px;
      height: 41px;
      margin: 0 auto;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
    &-title {
      max-width: 355px;
      font-size: 14px;
      color: #666666;
      letter-spacing: 1px;
      text-align: center;
      line-height: 20px;
      font-weight: 400;
      margin: 10px auto 32px auto;
    }
    .form-header {
      width: 368px;
      margin: 37px 0 18px 0;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      &.h-error {
        margin-top: 15px;
      }
    }
    &-form {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: 10px;
      margin-top: (-633px/2);
      width: 508px;
      height: 633px;
      padding: 48px 70px;
      background-color: white;
      border-radius: 10px;
    }
    @media screen and (max-width: 1100px) {
      &-form {
        margin-left: (-508px/2);
      }
    }
    &-links {
      font-size: 14px;
      color: #ac7f40;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      .divide {
        margin: 0 8px;
      }
    }
    .afi-username,
    .afi-password,
    .ant-form-item {
      width: 368px;
      margin-bottom: 24px;
    }
    .ant-form-item.ant-form-item-has-error {
      margin-bottom: 0px;
    }
    .ant-form-item-explain {
      padding-left: 10px;
    }
    .afi-code {
      .ant-form-item-control-input-content {
        display: flex;
        align-items: center;
      }
      .ant-input {
        min-width: 270px;
        margin-right: 8px;
      }
      .ant-btn {
        width: 90px;
        padding: 0 9px;
      }
    }
    .afi-btn-group {
      .ant-form-item-control-input-content {
        display: flex;
        align-items: center;
      }
      .afi-btn-reg {
        min-width: 270px;
        margin-right: 8px;
      }
      .afi-btn-login {
        width: 90px;
        padding: 0 9px;
      }
    }
    // .ant-form-item.ant-form-item-has-error {
    //   margin-bottom: 8px;
    // }
    // .ant-form-item-explain {
    //   padding-left: 10px;
    // }

    .ant-input {
      width: 100%;
      height: 40px;
      color: #333;
      font-size: 14px;
    }
    .ant-btn {
      width: 100%;
      height: 40px;
      border-radius: 2px;
    }
  }
  .btn-pwd {
    cursor: pointer;
  }
  .success-handel-panel {
    .svg-icon {
      width: 66px;
      height: 66px;
      margin: 40px auto 34px auto;
    }
    .success-tip {
      font-size: 20px;
      color: #333333;
      line-height: 28px;
      margin: 15px auto;
    }
    .success-tip {
      font-size: 14px;
      color: #666666;
      text-align: center;
      line-height: 22px;
      margin-bottom: 66px;
    }
    .success-btn-login {
      width: 368px;
      height: 40px;
      background: #ac7f40;
      border-radius: 2px;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 22px;
    }
    text-align: center;
  }
  .ant-form-item-explain,
  .ant-form-item-extra {
    font-size: 12px;
  }
  .record-number {
    text-align: center;
    a {
      font-size: 12px;
      color: #666666;
      font-size: 12px;
    }
  }
</style>
